"use client"

import { useEffect, useState } from "react"
import DashboardLayout from "../../components/Layout/DashboardLayout"
import MiniFooter from "../../components/Layout/miniFooter"
import api from "../../services/api"
import Breadcrumbs from "../../components/Layout/Breadcrumbs"

const BRAND = {
  primary: "#3B82F6",
  primaryDark: "#2563EB",
  soft: "rgba(59,130,246,.08)",
  border: "#E5E7EB",
  text: "#1F2937",
  muted: "#6B7280",
}

export default function CampaignTagsPage() {
  const [tags, setTags] = useState([])
  const [loading, setLoading] = useState(false)

  const [form, setForm] = useState({
    name: "",
    description: "",
    textColor: "#ffffff",
    bgColor: "#1ab394",
    isPublic: false,
  })


//   // Mocked flags – wire to backend later
//   const planAllowsTags = false
//   const isLimitExceeded = true

  useEffect(() => {
    fetchTags()
  }, [])

  const fetchTags = async () => {
    try {
      const res = await api.get("/tags")
      setTags(res.data?.data || [])
    } catch {
      setTags([])
    }
  }

  const handleCreate = async () => {
    if (!form.name.trim()) return alert("Campaign name is required")

    setLoading(true)
    try {
      await api.post("/tags", form)
      setForm({
        name: "",
        description: "",
        textColor: "#ffffff",
        bgColor: "#1ab394",
        isPublic: false,
      })
      fetchTags()
    } catch {
      alert("Failed to create campaign")
    } finally {
      setLoading(false)
    }
  }

      const breadcrumbItems = [{ name: "Dashboard", path: "/user-dashboard" }, { name: "Campaign Tags" }]

  return (
    <DashboardLayout>
      <div className="container py-4" style={{ maxWidth: 1000 }}>
        <Breadcrumbs items={breadcrumbItems} />
        {/* HEADER */}
        <div className="mb-4">
          <h3 className="fw-semibold mb-1">Campaign Tags</h3>
          <p className="text-muted">
            Group your short links into campaigns and view combined analytics.
          </p>
        </div>

        {/* WARNINGS */}
        {/* {isLimitExceeded && (
          <div className="alert alert-warning rounded-3">
            <strong>Usage Limit Reached</strong>
            <p className="mb-2">
              You’ve reached your monthly click limit. Upgrade to continue tracking without interruptions.
            </p>
            <button className="btn btn-sm btn-dark">Upgrade Plan</button>
          </div>
        )}

        {!planAllowsTags && (
          <div className="alert alert-info rounded-3">
            <strong>Upgrade Required</strong>
            <p className="mb-2">
              Campaign Tags are not available on your current plan.
            </p>
            <button className="btn btn-sm btn-outline-primary">View Plans</button>
          </div>
        )} */}

        {/* CREATE TAG */}
        <div
          className="rounded-4 p-4 mb-4"
          style={{ border: `1px solid ${BRAND.border}`, background: "#fff" }}
        >
          <h6 className="fw-semibold mb-3">Create Campaign Tag</h6>

          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Campaign Name *</label>
              <input
                className="form-control"
                placeholder="e.g. Facebook Ads"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                // disabled={!planAllowsTags}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Description</label>
              <input
                className="form-control"
                placeholder="Optional description"
                value={form.description}
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
                // disabled={!planAllowsTags}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Text Color</label>
              <input
                type="color"
                className="form-control form-control-color"
                value={form.textColor}
                onChange={(e) =>
                  setForm({ ...form, textColor: e.target.value })
                }
                // disabled={!planAllowsTags}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Background Color</label>
              <input
                type="color"
                className="form-control form-control-color"
                value={form.bgColor}
                onChange={(e) =>
                  setForm({ ...form, bgColor: e.target.value })
                }
                // disabled={!planAllowsTags}
              />
            </div>

            <div className="col-md-6 d-flex align-items-center">
              <div className="form-check mt-4">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={form.isPublic}
                  onChange={(e) =>
                    setForm({ ...form, isPublic: e.target.checked })
                  }
                //   disabled={!planAllowsTags}
                />
                <label className="form-check-label">
                  Enable Public Analytics
                </label>
              </div>
            </div>
          </div>

          <button
            className="btn btn-primary mt-4"
            style={{ background: BRAND.primaryDark }}
            disabled={ loading}
            onClick={handleCreate}
          >
            {loading ? "Creating..." : "Create Campaign"}
          </button>
        </div>

        {/* TAGS TABLE */}
        <div
          className="rounded-4 p-3"
          style={{ border: `1px solid ${BRAND.border}`, background: "#fff" }}
        >
          <h6 className="fw-semibold mb-3">Your Campaigns</h6>

          {tags.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <p className="mb-1 fw-semibold">No Campaign Tags Yet</p>
              <p>Create your first campaign to group links and track performance.</p>
            </div>
          ) : (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>Campaign</th>
                  <th>Description</th>
                  <th>Analytics</th>
                  <th>Public</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tags.map((tag) => (
                  <tr key={tag._id}>
                    <td>
                      <span
                        className="badge rounded-pill"
                        style={{
                          background: tag.bgColor,
                          color: tag.textColor,
                        }}
                      >
                        {tag.name}
                      </span>
                    </td>
                    <td className="text-muted">{tag.description || "-"}</td>
                    <td>{tag.totalClicks || 0} clicks</td>
                    <td>{tag.isPublic ? "Yes" : "No"}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-secondary">
                        Manage
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

      </div>
      <MiniFooter />
    </DashboardLayout>
  )
}